module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-col', {
    staticClass: "login",
    attrs: {
      "xs": {
        offset: 1,
        span: 22
      },
      "md": {
        offset: 8,
        span: 8
      }
    }
  }, [_c('div', {
    staticClass: "panelheader"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.pageName))])]), _vm._v(" "), _c('div', {
    staticClass: "login-wrapper"
  }, [_c('loginform', {
    attrs: {
      "redirect": "/sites"
    }
  })], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-99211752","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Login.vue
// module id = 730
// module chunks = 15